import { createSlice } from '@reduxjs/toolkit'

export type ServiceInventoryState = {
  selectedButtonState: string[]
}

const initialState: ServiceInventoryState = {
  selectedButtonState: ['ACTIVE'],
}

const serviceInventorySlice = createSlice({
  name: 'serviceInventory',
  initialState,
  reducers: {
    setInventorySelectedButton: (state, action) => {
      state.selectedButtonState = action.payload
    },
  },
})

export const { setInventorySelectedButton } = serviceInventorySlice.actions
export default serviceInventorySlice.reducer
